export const tabs = () => [
  { name: "Overview", href: `overview` },
  {
    name: "Gallery",
    href: `gallery`,
  },
  { name: "Events", href: `events` },
];
